import React from 'react';
import appVersion from '../../../generated/app-version.json';
import './AppFooter.scss';

export const AppFooter = ({ ...rest }) => {
  return <footer className='footer' {...rest}>Versie {appVersion.version}</footer>;
};
